import React from "react";
import { Box, Checkbox } from "flux";
import {
  PublisherPlatforms,
  AudienceNetworkPlacementPositions,
  FacebookPlacementPositions,
  InstagramPlacementPositions,
  MessengerPlacementPositions
} from "../../features/ad-publishing/types";

import { PositionType, PlacementDisplayNames } from "../../features/ad-publishing/helpers";

interface PositionCheckboxesProps {
  positions: PositionType[];
  platform: PublisherPlatforms;
  onChange: (positions: PositionType[]) => void;
  disabled?: boolean;
}

export const PositionCheckboxes: React.FC<PositionCheckboxesProps> = ({ positions, platform, onChange, disabled }) => {
  const handleChange = (position: PositionType) => {
    if (disabled) return;

    const newPositions = positions?.includes(position)
      ? positions?.filter((p) => p !== position)
      : [...positions, position];
    onChange(newPositions);
  };

  const getAvailablePositions = (platform: PublisherPlatforms): PositionType[] => {
    switch (platform) {
      case PublisherPlatforms.FACEBOOK: {
        return Object.values(FacebookPlacementPositions);
      }
      case PublisherPlatforms.INSTAGRAM: {
        return Object.values(InstagramPlacementPositions);
      }
      case PublisherPlatforms.AUDIENCE_NETWORK: {
        return Object.values(AudienceNetworkPlacementPositions);
      }
      case PublisherPlatforms.MESSENGER: {
        return Object.values(MessengerPlacementPositions);
      }
      default: {
        return [];
      }
    }
  };

  const availablePositions = getAvailablePositions(platform);

  return (
    <Box>
      <Box display="flex" flexDirection="column" gap={1}>
        {availablePositions.map((position) => (
          <label
            key={position}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              opacity: disabled ? 0.5 : 1,
              cursor: disabled ? "not-allowed" : "pointer"
            }}
          >
            <Checkbox
              size="large"
              checked={Boolean(positions?.includes(position))}
              onChange={() => handleChange(position)}
              disabled={disabled}
              dataDogIdentifier="platform position"
            />
            <span>{PlacementDisplayNames[`${platform.toLowerCase()}.${position}`]}</span>
          </label>
        ))}
      </Box>
    </Box>
  );
};
